module.exports = __webpack_public_path__ + "media/images/admin/icons/trash-a864b6b6ee9ef0386c78eef0d2982559.svg";